import { render, staticRenderFns } from "./PromoCard.vue?vue&type=template&id=50e30f88&scoped=true&"
import script from "./PromoCard.vue?vue&type=script&lang=js&"
export * from "./PromoCard.vue?vue&type=script&lang=js&"
import style0 from "./PromoCard.vue?vue&type=style&index=0&id=50e30f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e30f88",
  null
  
)

export default component.exports